(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const radioButtons = document.querySelectorAll('[name="faq_tags"]');
    function updateFAQVisibility() {
      const checked = document.querySelector('[name="faq_tags"]:checked');
      if (!checked) return;

      const checkedTag = checked.value.toLowerCase();
      const allItems = document.querySelectorAll('[data-tag]');
      
      allItems.forEach((el) => {
        if (el.dataset.tag === checkedTag) {
          el.classList.add('showAccordion');
        } else {
          el.classList.remove('showAccordion');
        }
      });
    }

    updateFAQVisibility();
    radioButtons.forEach((radio) => {
      radio.addEventListener('change', updateFAQVisibility);
    });


    const accordionHeaders = document.querySelectorAll(".accordion .faq");
    accordionHeaders.forEach((header) => {
      header.classList.add("set-arrow");

      header.addEventListener("click", function () {
        const currentlyActive = document.querySelector(".accordion .faq.active");
        const answer = header.nextElementSibling;

        if (currentlyActive && currentlyActive !== header) {
          currentlyActive.classList.remove("active");
          const activeAnswer = currentlyActive.nextElementSibling;
          if (activeAnswer && activeAnswer.classList.contains("answer")) {
            activeAnswer.style.display = "none";
          }
        }

        const isActive = header.classList.toggle("active");
        if (answer && answer.classList.contains("answer")) {
          answer.style.display = isActive ? "block" : "none";
        }
      });

      const answer = header.nextElementSibling;
      if (answer && answer.classList.contains("answer")) {
        answer.style.display = "none";
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.collectionHeader = document.querySelector('.collection-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // this.setHeaderHeight();
      window.addEventListener('load', () => this.setHeaderHeight());
      requestAnimationFrame(() => this.setHeaderHeight());

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > 1) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > 1) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();

      if (this.collectionHeader) {
        this.collectionHeader.classList.add('collection-header-hidden', 'collection-header-sticky');
      }
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if (this.collectionHeader) {
        this.collectionHeader.classList.add('collection-header-sticky', 'animate');
        this.collectionHeader.classList.remove('collection-header-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
